module.exports = __webpack_public_path__ + "static/media/icon_extension_ply.1c94a401.svg";